import { currentUserQueryKey } from '@entities/users/apis/user-query-key'
import { queryOptions } from '@tanstack/react-query'

import { getCurrentUser } from './get-current-user'
import { getSignupDropoutPromotion } from './get-signup-dropout-promotion'
import { getWelcomeBackPromotion } from './get-welcomeback-promotion'

export const userEntityQueries = {
  all: ['users'],

  getCurrentUserQueryKey: ({ bearerToken }: RequestQueryOptions) => currentUserQueryKey(bearerToken),
  getCurrentUser: ({ bearerToken, timeoutMs }: RequestQueryOptions & { timeoutMs?: number }) =>
    queryOptions({
      queryKey: userEntityQueries.getCurrentUserQueryKey({ bearerToken }),
      queryFn: async ({ signal }) => await getCurrentUser(bearerToken, { signal, timeoutMs }),
    }),

  getWelcomeBackPromotionQueryKey: ({ bearerToken }: RequestQueryOptions) => [
    ...userEntityQueries.all,
    'getWelcomeBackPromotion',
    bearerToken,
  ],
  getWelcomeBackPromotion: ({ bearerToken }: RequestQueryOptions) =>
    queryOptions({
      queryKey: userEntityQueries.getWelcomeBackPromotionQueryKey({ bearerToken }),
      queryFn: async () => await getWelcomeBackPromotion(bearerToken),
      staleTime: 1000 * 60 * 5, // 5분 캐싱
    }),

  getSignupDropoutPromotionQueryKey: ({ bearerToken }: RequestQueryOptions) => [
    ...userEntityQueries.all,
    'getSignupDropoutPromotion',
    bearerToken,
  ],
  getSignupDropoutPromotion: ({ bearerToken }: RequestQueryOptions) =>
    queryOptions({
      queryKey: userEntityQueries.getSignupDropoutPromotionQueryKey({ bearerToken }),
      queryFn: async () => await getSignupDropoutPromotion(bearerToken),
      staleTime: 1000 * 60 * 5, // 5분 캐싱
    }),
} as const
